import { MutableRefObject, useEffect } from 'react';

export const useDetectClickOutside = (refs: Array<MutableRefObject<any>>, callback: () => void) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      refs.forEach(ref => {
        if (ref.current && !ref.current.contains(event.target as Node)) {
          callback();
        }
      });
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
};
